// extracted by mini-css-extract-plugin
export var progressContainer = "_jj-0";